import {
  createContext,
  useContext,
} from 'react'

const UserTagsContext = createContext()

export default UserTagsContext

export function useUserTags() {
  return useContext(UserTagsContext)
}
